import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hand static search metadata to the live route metadata before mounting.
document.querySelectorAll('head [data-search-html="true"]').forEach(node => node.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
